import { PageErrorNoRouting } from '../../pages/PageError';
import { CacheProvider } from '../../shared/components/CacheContext';
import EqxErrorBoundary from '../../shared/components/EqxErrorBoundary';
import { OfflineProvider } from './AppOfflineContext';

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/bootstrap.scss';

import '../../assets/Continuum-go.css';
import '../../assets/Continuum.css';

import '../../assets/App.css';
import '../../assets/Continuum-go.css';

import '../../assets/login.css';

//import { AuthProvider } from './components/Auth';

import AppApiProvider from './AppApi';
import { AppGlobalConfigProvider } from './AppGlobalConfig';
import { AppTenantlessApiProvider } from './AppTenantlessApi';
import AppAuthOAuthProvider from './AppAuthOAuth';
import AppAuthProvider from './AppAuth';
import AppBaseConfigProvider from './AppBaseConfig';
import AppDeploymentProvider from './AppDeploymentProvider';
import { AppTenantlessDeploymentProvider } from './AppTenantlessDeploymentProvider';
import AppMaintenanceHandlerProvider from './AppMaintenanceHandler';
import AppRouter from './AppRouter';
import AppTenantProvider from './AppTenant';
import SyncfusionLicenseManager from './SyncfusionLicense';
import AppMSClarityTags from './AppMSClarityTags';

// app
// - error boundary
// - - config
// - - - tenantless deployment (environment / domain / instance)
// - - - - tenantless api
// - - - - global config (GET /config/global, session-cached)
// - - - - MSAL (organizations) & root sign-in gate
// - - - - deployment & tenant bootstrap
// - - - - - api (tenanted)
// - - - - - maintenance (426 on *tenanted* api — must stay below AppApiProvider)
// - - - - - - tenant
// - - - - - auth provider
// - - - - - - router
// - - - - - - - token provider (require auth)
// - - - - - - - - main layout
// - - - - - - - - - page

/**
 * configure the app
 */

interface AppProps { }
const App = (props: AppProps) => {
    return (
        <>
            <EqxErrorBoundary fallback={<PageErrorNoRouting />}>
                <CacheProvider>
                    <AppBaseConfigProvider>
                        <AppTenantlessDeploymentProvider>
                            <AppTenantlessApiProvider>
                                <AppGlobalConfigProvider>
                                    <AppAuthOAuthProvider>
                                        <AppDeploymentProvider>
                                            <AppApiProvider>
                                                <AppMaintenanceHandlerProvider>
                                                    <AppTenantProvider>
                                                        <SyncfusionLicenseManager />
                                                        <AppAuthProvider>
                                                            <AppMSClarityTags />
                                                            <OfflineProvider>
                                                                <AppRouter />
                                                            </OfflineProvider>
                                                        </AppAuthProvider>
                                                    </AppTenantProvider>
                                                </AppMaintenanceHandlerProvider>
                                            </AppApiProvider>
                                        </AppDeploymentProvider>
                                    </AppAuthOAuthProvider>
                                </AppGlobalConfigProvider>
                            </AppTenantlessApiProvider>
                        </AppTenantlessDeploymentProvider>
                    </AppBaseConfigProvider>
                </CacheProvider>
            </EqxErrorBoundary>
        </>
    )
}
export { App as default };

